import { Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions, Button, Typography, Box, IconButton, Switch, TextField, FormControl, InputLabel, MenuItem, Select, Tooltip } from '@mui/material';
import { useContext, useEffect, useState } from 'react';
import { Close } from '@mui/icons-material';
import navbar_background from '../assets/navbar_background.svg';
import useFetch from '../hooks/useFetch';
import endpoints from '../constants/endpoints';
import useApiRequest from '../services/apiRequest';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import DeleteIcon from '@mui/icons-material/Delete';
import VisibilityIcon from '@mui/icons-material/Visibility';
import LogsDialog from './LogsDialog';
import { GlobalStateContext } from '../wrappers/GlobalContext';
import AddIcon from '@mui/icons-material/Add';
import NewUserDialog from './NewUserDialog';
import ControlPointIcon from '@mui/icons-material/ControlPoint';


type Props = {
    open: boolean,
    onClose: (() => void)
}

function AdminDialog({ open, onClose }: Props) {
    const { get, post, queryStringConverter, remove } = useApiRequest();

    const { currentUser, setCurrentUser } = useContext(GlobalStateContext);
    const [query, setQuery] = useState(queryStringConverter({ page: 0, size: 10, }));
    const { userPermissions, setUserPermissions } = useContext(GlobalStateContext);
    const { data, error, loading } = useFetch(`${endpoints.GET_USERS}${query}`)
    const [openDelete, setOpenDelete] = useState(false);
    const [openUserLogs, setOpenUserLogs] = useState(false);
    const [openNewUser, setOpenNewUser] = useState(false);
    const [selectedUser, setSelectedUser] = useState('');
    const [searchUsers, setSearchUsers] = useState('');

    const [pageSizeFacet, setPageSizeFacet] = useState<number>(10);
    const [currentPageFacet, setCurrentPageFacet] = useState<number>(0);


    function ConfirmDeleteDialog({ open, onClose, user }: { open: boolean, onClose: (() => void), user: string }) {

        const handleDelete = async () => {
            await remove(`${endpoints.DELETE_USER}/${currentUser?.profile.username}` + `?user=${user}`).then(() => { getUsers(); setOpenDelete(false) });
        }

        return (
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle>Excluir usuário</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-slide-description">
                        Tem certeza que deseja excluir o usuário {user}?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancelar</Button>
                    <Button onClick={handleDelete} variant='contained' color='error'>Excluir</Button>
                </DialogActions>
            </Dialog>
        )
    }

    const chanchePermission = (id: number, permission: string, value: boolean) => {
        let userEdit = {}
        let currentUser = false;
        data.results.forEach((user: any) => {
            if (user.id === id) {
                user[permission] = value;
                userEdit = user;
                user['usuario'] == userPermissions.usuario ? currentUser = true : currentUser = false;
            }
        })

        post(endpoints.CREATE_EDIT_USER, userEdit).then(() => {
            getUsers()
            if (currentUser) {
                getPermissions();
            }
        })

    }
    const renderPermissionsSwitch = (params: any, permission: string) => {
        return (
            <Box>
                <Switch
                    checked={params.row[permission]}
                    onChange={(e) => { chanchePermission(params.row.id, permission, e.target.checked) }}
                    inputProps={{ 'aria-label': 'controlled' }}
                    disabled={isDisabled(params.row.type, params.row.usuario)}
                />
            </Box>
        )
    }
    const getPermissions = async () => {
        const resp = await get(endpoints.USER_PERMISSIONS, { user: currentUser?.profile.username })
        setUserPermissions(resp)
    }

    const chancheUserType = (id: number, permission: string, value: string) => {
        let userEdit: any = {}
        let currentUser = false;
        data.results.forEach((user: any) => {
            if (user.id === id) {
                user['type'] = value;
                userEdit = user;
                user['usuario'] == userPermissions.usuario ? currentUser = true : currentUser = false;
            }
        })

        post(endpoints.CREATE_EDIT_USER, userEdit).then(() => {
            getUsers()
            if (currentUser) {
                if (userEdit['type'] == 'user') {
                    onClose();
                }
                getPermissions();
            }
        })


    }

    const renderDeleteUser = (params: any) => {
        return (
            <Box>
                <Button size='small' variant='contained' color='error' startIcon={<DeleteIcon />} disabled={isDisabled(params.row.type, params.row.usuario)} onClick={() => handleDeleteUser(params.row.usuario)}>Excluir</Button>
            </Box>
        )
    }

    const handleDeleteUser = async (user: string) => {
        setOpenDelete(true);
        setSelectedUser(user);
    }

    const handleSeeUserLogs = (user: string) => {
        setOpenUserLogs(true);
        setSelectedUser(user);
    }

    const renderUserLogs = (params: any) => {
        return (
            <Box>
                <Button size='small' variant='contained' color='info' startIcon={<VisibilityIcon />} disabled={isDisabledLog(params.row.type, params.row.usuario)} onClick={() => { handleSeeUserLogs(params.row.usuario) }}>Logs</Button>
            </Box>
        )
    }

    const renderUserType = (params: any) => {
        return (
            <Box>
                <FormControl fullWidth>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={params.row.type}
                        label=""
                        onChange={(e) => { chancheUserType(params.row.id, 'type', e.target.value) }}
                        size='small'
                        disabled={isDisabledLevel(params.row.type, params.row.usuario)}
                    >
                        <MenuItem value={'user'}>Usuário</MenuItem>
                        <MenuItem value={'admin'}>Administrador</MenuItem>
                        <MenuItem disabled={userPermissions.type != 'super admin'} value={'super admin'}>Super Adminitrador</MenuItem>
                    </Select>
                </FormControl>
            </Box>)
    }

    const isDisabledLevel = (type: string, user: string) => {
        if (userPermissions.type == 'super admin') {
            if (type == 'super admin' && user != userPermissions.usuario) {
                return true;
            } else {
                return false;
            }

        } else {
            return true
        }

    }

    const isDisabled = (type: string, user: string) => {
        if (userPermissions.type == 'super admin' && type == 'super admin' && userPermissions.usuario != user) {
            return true;
        } else {
            if (userPermissions.type == 'admin' && type != 'user') {
                if (userPermissions.usuario == user) {
                    return false;
                }
                return true;
            }
            return false;
        }

    }

    const isDisabledLog = (type: string, user: string) => {
        if (userPermissions.type == 'admin' && type != 'user') {
            if (userPermissions.usuario == user) {
                return false;
            }
            return true;
        }
        return false;

    }


    const columns: GridColDef[] = [
        {
            field: 'usuario',
            headerName: 'Usuário',
            width: 150,
        },
        {
            field: 'type',
            headerName: 'Nível',
            width: 200,
            sortable: false,
            renderCell: renderUserType,
        },
        {
            field: 'get_aggregate',
            headerName: 'Calcular sobrepreço',
            width: 130,
            sortable: false,
            renderCell: (params: any) => renderPermissionsSwitch(params, 'get_aggregate'),
        },
        {
            field: 'print_list_items',
            headerName: 'Fazer busca',
            width: 100,
            sortable: false,
            renderCell: (params: any) => renderPermissionsSwitch(params, 'print_list_items'),
        },
        {
            field: 'generate_file',
            headerName: 'Gerar arquivo',
            width: 100,
            sortable: false,
            renderCell: (params: any) => renderPermissionsSwitch(params, 'generate_file'),
        },
        {
            field: 'get_file',
            headerName: 'Baixar arquivo',
            width: 120,
            sortable: false,
            renderCell: (params: any) => renderPermissionsSwitch(params, 'get_file'),
        },
        {
            field: 'delete_file',
            headerName: 'Apagar arquivo',
            width: 120,
            sortable: false,
            renderCell: (params: any) => renderPermissionsSwitch(params, 'delete_file'),
        },
        {
            field: 'user_logs',
            headerName: 'Logs',
            width: 100,
            sortable: false,
            renderCell: (params: any) => renderUserLogs(params),
        },

        {
            field: 'delete_user',
            headerName: 'Excluir usuário',
            width: 120,
            sortable: false,
            renderCell: (params: any) => renderDeleteUser(params),
        },

    ];

    const getUsers = async () => {
        const addSpace = query.endsWith(' ') ? '' : ' ';
        if (searchUsers === '') {
            setQuery(queryStringConverter({ page: currentPageFacet, size: pageSizeFacet }) + addSpace);
        } else {
            setQuery(`?${searchUsers.split(';').map((n) => `users=${n}`).join('&')}` + `&page=${currentPageFacet}&order=desc&size=${pageSizeFacet}&sort=usuario` + addSpace);
        }
    };


    const handleSearchUsers = async () => {
        if (searchUsers === '') {
            getUsers();
            return;
        }
        const usersStr = searchUsers.replaceAll(' ', '');
        const users = usersStr.split(';');
        setQuery(`?${users.map((n) => `users=${n}`).join('&')}` + `&page=0&order=desc&size=10&sort=usuario`);
    }

    useEffect(() => {
        getUsers();
    }, [open, openNewUser])

    return (
        <>
            <Dialog
                open={open}
                keepMounted
                onClose={onClose}
                aria-describedby="alert-dialog-slide-description"
                fullWidth
                maxWidth='md'
                PaperProps={{
                    sx: {
                        minHeight: '95vh', 
                        maxHeight: '95vh', 
                        minWidth: '50vw', 
                        maxWidth: '70vw',
                    }
                }}
            >
                <DialogTitle color='white' sx={{ bgcolor: '#00617b', backgroundImage: `url(${navbar_background})`, backgroundSize: "cover" }}>
                    <Typography variant='h4'>Usuários</Typography>
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 15,
                            top: 15,
                        }}
                    >
                        <Close sx={{ color: "white" }} />
                    </IconButton>
                </DialogTitle>
                <DialogContent sx={{ m: 2, display: 'flex', flexDirection: 'column' }}>
                    <ConfirmDeleteDialog open={openDelete} onClose={() => { setOpenDelete(false) }} user={selectedUser} />
                    <LogsDialog open={openUserLogs} onClose={() => { setOpenUserLogs(false); }} user={selectedUser} />
                    <NewUserDialog open={openNewUser} onClose={() => { setOpenNewUser(false); }} />

                    <Box sx={{ my: 1, display: 'flex' }}>
                        <TextField sx={{ flexGrow: 1 }} value={searchUsers} onChange={(ev) => { setSearchUsers(ev.target.value) }} id="outlined-basic" label="Pesquisar usuários" variant="outlined" />
                        <Button sx={{ ml: 2 }} onClick={handleSearchUsers} variant='contained' size='small'>Pesquisar</Button>
                        <Tooltip title="Novo usuário">
                            <IconButton aria-label="delete" onClick={() => setOpenNewUser(true)} size="large" sx={{ ml: 3 }}>
                                <ControlPointIcon color='primary' />
                            </IconButton>
                        </Tooltip>

                    </Box>

                    <Box sx={{ height: 500, width: '100%' }}>
                        <DataGrid
                            hideFooterSelectedRowCount
                            paginationMode='server'
                            pageSize={pageSizeFacet}
                            rows={data?.results || []}
                            rowCount={data?.total || []}
                            page={currentPageFacet}
                            onPageSizeChange={(newPageSize) => {
                                setPageSizeFacet(newPageSize);
                                searchUsers === '' ? setQuery(queryStringConverter({ page: currentPageFacet, size: newPageSize })) : setQuery(`?${searchUsers.split(';').map((n) => `users=${n}`).join('&')}` + `&page=${currentPageFacet}&order=desc&size=${newPageSize}&sort=usuario`);
                            }}
                            onPageChange={(newPage) => {
                                setCurrentPageFacet(newPage);
                                searchUsers === '' ? setQuery(queryStringConverter({ page: newPage, size: pageSizeFacet })) : setQuery(`?${searchUsers.split(';').map((n) => `users=${n}`).join('&')}` + `&page=${newPage}&order=desc&size=${pageSizeFacet}&sort=usuario`);
                            }}
                            columns={columns}
                            sx={{ fontSize: 13 }}
                            rowsPerPageOptions={[10, 25, 50]}
                            loading={loading}
                        />
                    </Box>
                </DialogContent>
            </Dialog>

        </>

    );
}
export default AdminDialog;
